import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from '../../../services/events/event.service';

@Component({
  selector: 'app-event-home',
  templateUrl: './event-home.component.html',
  styleUrls: ['./event-home.component.css'],
})
export class EventHomeComponent implements OnInit {
  events: Array<any> = [];

  lastDatePosition: string;

  dateCount: number = 0;

  todayStr: string;

  constructor(private eventService: EventService, private router: Router) {
    this.todayStr = moment().format('dddd MMM DD YYYY');
    this.eventService.home().then((response_json) => {
      this.events = response_json;
      if (this.events[0]) this.lastDatePosition = this.events[0].date_position;
      let dateCount: number = 0;
      let lastDatePosition: string = this.lastDatePosition;
      for (let event_obj of this.events) {
        event_obj.event_title = this.eventService.getEventTitle(event_obj.start, event_obj.end, event_obj.s_offset, event_obj.e_offset);
        event_obj.isToday = this.isToday(event_obj.date_position);
        event_obj.isPast = this.isPast(event_obj.start);
        if(lastDatePosition != event_obj.date_position){
          dateCount += 1;
          lastDatePosition = event_obj.date_position
        }
        event_obj.date_count = dateCount;
      }
      if (this.events[0]) this.lastDatePosition = this.events[0].date_position;
    });
  }

  // Component lifecycle events
  ngOnInit() {}

  // Component methods
  setLastDatePosition(newDatePosition: string): string {
    this.lastDatePosition = newDatePosition;
    this.dateCount += 1;
    return this.lastDatePosition;
  }

  openNewEvent(dateParam: any) {
    dateParam = moment(dateParam).format('YYYY-MM-DD');
    this.router.navigateByUrl(`/events?new_event=true&date=${dateParam}`);
  }

  isToday(datePosition: string): boolean {
    return datePosition === this.todayStr;
  }

  isPast(eventStart: string): boolean {
    return moment(eventStart).isBefore(moment(), 'minute');
  }
}
